import IMask from 'imask';

import dispatchCustomEvent from '../../../utils/dispatch-custom-event';
import Base from '../../base';

import formEvents from './calculator-form-events';
import formOptions from './calculator-form-options';
import PeriodSelector from './calculator-form-period-selector';

class WarrantsCalculatorForm extends Base {
	constructor(el) {
		super(el);

		this.isinInput = this.query('[name="isin"]');
		this.volatilityInput = this.query('[name="volatility"]');
		this.underlyingRateInput = this.query('[name="expectedUnderlyingRate"]');
		this.periodSelectorElement = this.query('.js-period-selector');

		this.start();
	}

	get formData() {
		return {
			expectedUnderlyingRate: this.underlyingRateFormatted.unmaskedValue,
			volatility: this.volatilityFormatted.unmaskedValue,
			amountOfDays: this.periodSelector.days,
			isin: this.isinInput.value,
		};
	}

	start() {
		formOptions.set(this.options);

		this.underlyingRateFormatted = new IMask(this.underlyingRateInput, {
			mask: Number,
			radix: formOptions.get('decimalSeparator'),
			scale: formOptions.get('decimalPrecision'),
			thousandsSeparator: formOptions.get('thousandSeparator'),
			padFractionalZeros: true,
			signed: false,
		});

		this.volatilityFormatted = new IMask(this.volatilityInput, {
			mask: Number,
			radix: formOptions.get('decimalSeparator'),
			scale: formOptions.get('decimalPrecision'),
			thousandsSeparator: formOptions.get('thousandSeparator'),
			padFractionalZeros: true,
			signed: false,
			min: 1,
		});

		this.periodSelector = new PeriodSelector(this.periodSelectorElement);

		this.on('submit');
	}

	onSubmit(e) {
		e.preventDefault();

		const { formData } = this;

		dispatchCustomEvent(this.el, formEvents.FORM_SUBMITTED, formData);
	}
}

export default WarrantsCalculatorForm;
